import { EventType } from '../enums/eventType';
import { ApiResponse, BASE_API_URL, HttpMethod, httpRequest } from './sharedApi';

const THRESHOLD_URL = `${BASE_API_URL}/PpaConditions`;

export enum FieldOptions {
    //Power = 'Power',
    //ReactivePower = 'ReactivePower',
    Capacity = 'Capacity',
}

export enum ConditionOptions {
    LessThanOrEqual = 'LessThanOrEqual',
    LessThan = 'LessThan',
    Equal = 'Equal',
    GreaterThan = 'GreaterThan',
    GreaterThanOrEqual = 'GreaterThanOrEqual',
}

export interface ThresholdConditionDto {
    siteName: string;
    eventType: EventType;
    field: FieldOptions;
    eventCondition: ConditionOptions;
    minimumDuration: number;
    value: number;
    siteKey: string;
    id: number;
}

export const getAllThresholdConditions = (): Promise<ApiResponse<ThresholdConditionDto[]>> => {
    return httpRequest<ThresholdConditionDto[]>(THRESHOLD_URL, HttpMethod.GET);
};

export const getThresholdConditionById = (id: number): Promise<ApiResponse<ThresholdConditionDto>> => {
    return httpRequest<ThresholdConditionDto>(`${THRESHOLD_URL}/${id}`, HttpMethod.GET);
};

export const createThresholdCondition = (
    condition: ThresholdConditionDto,
): Promise<ApiResponse<ThresholdConditionDto>> => {
    return httpRequest<ThresholdConditionDto>(THRESHOLD_URL, HttpMethod.POST, condition);
};

export const updateThresholdCondition = (
    condition: ThresholdConditionDto,
): Promise<ApiResponse<ThresholdConditionDto>> => {
    return httpRequest<ThresholdConditionDto>(`${THRESHOLD_URL}/${condition.id}`, HttpMethod.PUT, condition);
};

export const deleteThresholdCondition = (condition: ThresholdConditionDto): Promise<ApiResponse<void>> => {
    return httpRequest(`${THRESHOLD_URL}/${condition.id}`, HttpMethod.DELETE);
};
